import './common-styles';
import '@/styles/dmq-auth.scss';

import './common-code';

const loginToggle = document.getElementById('login_toggle') as (HTMLElement | null);
const showLoginButton = document.getElementById('show_login_button') as (HTMLElement | null);
const loginForm = document.getElementById('login_form') as (HTMLElement | null);
const signupToggle = document.getElementById('signup_toggle') as (HTMLElement | null);
const showSignupButton = document.getElementById('show_signup_button') as (HTMLElement | null);
const signupForm = document.getElementById('signup_form') as (HTMLElement | null);
if (loginToggle && showLoginButton && loginForm && signupToggle && showSignupButton && signupForm) {
  showSignupButton.onclick = (() => {
    loginToggle.classList.remove('dmq-auth-hidden');
    loginForm.classList.add('dmq-auth-hidden');
    signupToggle.classList.add('dmq-auth-hidden');
    signupForm.classList.remove('dmq-auth-hidden');
    signupForm.querySelectorAll('input[name=name]').forEach((el) => {
      (el as HTMLElement).focus();
    });
  });
  showLoginButton.onclick = (() => {
    loginToggle.classList.add('dmq-auth-hidden');
    loginForm.classList.remove('dmq-auth-hidden');
    signupToggle.classList.remove('dmq-auth-hidden');
    signupForm.classList.add('dmq-auth-hidden');
    loginForm.querySelectorAll('input[name=login]').forEach((el) => {
      (el as HTMLElement).focus();
    });
  });
}
